export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
